import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import useOnScreen from 'lib/hooks/useOnScreen';

import styles from './listingDetailCarousel.module.less';

const SLIDE_ANIMATION_MS = 500;

const SLIDER_SETTINGS: Settings = {
  autoplaySpeed: 1500,
  speed: SLIDE_ANIMATION_MS,
  pauseOnHover: false,
  infinite: true,
  nextArrow: <></>,
  prevArrow: <></>,
};

type ListingDetailCarouselProps = {
  items: JSX.Element[];
};

export const ListingDetailCarousel = ({ items }: ListingDetailCarouselProps): JSX.Element => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const sliderRef = useRef<Slider>(null);

  const isOnScreen = useOnScreen(wrapperRef.current);

  return (
    <div className={styles.carouselWrapper} ref={wrapperRef}>
      {items[0]}
      {isOnScreen && (
        <div
          className={styles.carousel}
          onMouseEnter={() => sliderRef.current?.slickPlay()}
          onMouseLeave={() => {
            // Stop auto sliding
            sliderRef.current?.slickPause();
            // Make sure the current slide animation is done, then reset slider.
            setTimeout(() => sliderRef.current?.slickGoTo(0), SLIDE_ANIMATION_MS);
          }}
        >
          <Slider {...SLIDER_SETTINGS} ref={sliderRef}>
            {items}
          </Slider>
        </div>
      )}
    </div>
  );
};
